<style lang="scss" scoped>

textarea,
input.text,
input[type="text"],
input[type="button"],
input[type="submit"] {
  -webkit-appearance: none;
  border-radius: 0;
}
.pagination {
  width: 100%;
  display: flex;
  justify-content: flex-end;
  align-items: center;
  margin: 10px 0;
  border-radius:0;
  @media (max-width: 768px) {
    justify-content: center;
    margin-top: 10px;
  }
  .middle-input-nr {
    margin: 0 10px;
    input {
      width: 70px;
      text-align: center;
      padding: 7px 7px 7px 7px;
      border: 1px solid #ccc;
      margin-right: 5px;
      -webkit-appearance: none;
      border-radius: 0;
      outline: none;
      font-size:100%;
      @media (max-width: 1025px) {
        padding: 7px 7px 8px 7px;
      }
      &:focus {
        border: 1px solid #ccc;
      }
    }
  }
  button {
    // margin: 0 10px;
    padding: 5px 10px;
    border: 0;
    outline: none;
    background:#eee;
    @media (max-width: 1025px) {
      padding: 5px 10px;
    }
    i {
      position: relative;
      top: 3px;
    }
    &:hover {
      cursor: pointer;
      background:#f1f1f1;
    }
  }
}
</style>

<template>
  <div class="pagination">
    <button @click="switchPage('prev')" :disabled="activePage <= 1"><i class="material-icons">keyboard_arrow_left</i></button>
    <span class="middle-input-nr"><input type="number" v-model="activePage" @input="setPage" />&nbsp;von {{ maxPages }}</span>
    <button @click="switchPage('next')" :disabled="activePage >= maxPages"><i class="material-icons">keyboard_arrow_right</i></button>
  </div>
</template>

<script>
import Vue from 'vue';

export default Vue.extend({
  name: "Pagination",
  props: ["maxPages", "activePage", "prev", "next"],
  methods: {
    setPage() {
      if (this.activePage == "" || this.activePage <= 0) this.activePage = 1;
      this.$emit("input", this.activePage);
    },
    switchPage(dir) {
      let page = 1;
      if (dir == "prev") {
        page = this.activePage - 1;
        if(typeof this.prev === "function")
          this.prev();
      } else {
        page = this.activePage + 1;
        if(typeof this.next === "function")
          this.next();
      }
      this.$emit("input", page > this.maxPages ? this.maxPages : page);
    }
  }
});
</script>
